<script>
    import LoadingBlock from "./reservation/LoadingBlock.svelte";
    import Calendars from "./Calendars.svelte";
    import DateConfirmator from "./DateConfirmator.svelte"


    const delay = ms => new Promise(res => setTimeout(res, ms));
   

    let selectedDate = new Date();
    let selectedService = "na_hrázi";
    let selectedTime;
    let selectedName;
    let selectedEmail;
    let selectedPhone;

    let sent = false;

    let services = [
        {
            id: "na_hrázi",
            text: "Na Hrázi"
        }
    ]

    async function downloadData(selected_date, service) {
        console.log(selectedDate, selectedService);

        const response = await fetch(
            'wp-json/rs/v1/available?res_place_uuid=' + service + 
            '&date=' + selected_date.getFullYear() + '-' +  ('0' + (selected_date.getMonth() + 1)).slice(-2) + '-' + ('0' + selected_date.getDate()).slice(-2),
            {
                cache: 'no-store'
            }
        );
        const data = await response.json();
        if (!response.ok) {
            throw new Error('There was a problem with the fetch operation: Network response was not ok');
        }

        console.log(data);  // Zpracování získaných dat
        return data;

    }

    let promiseDownloadData = downloadData(selectedDate, selectedService);

    $: tmp = changeRealDate(selectedDate);

    function changeRealDate() {
        if(selectedDate.getTime() != selected_real_date.getTime()) {
            selected_real_date = selectedDate;
        }
    }


    let selected_real_date = new Date();

    async function handleSubmit() {
        console.log("Handle");
        return await reserveRequest(selectedService, selectedTime.start_time, selectedEmail, selectedPhone, selectedName);
        
    }

    async function reserveRequest(res_uuid, datetime, email, phone, name) {
        console.log("Reserve");
        const url = '/wp-json/rs/v1/reserve'; // Nahraďte 'your_namespace' správným namespace

        const requestBody = {
            "res_uuid": res_uuid,
            "date": datetime,
            "email": email,
            "phone": phone,
            "name" : name
        };

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Error: ${response.status} - ${errorText}`);
        }

        const data = await response.text();
        console.log('Success:', data);
        return data;

    }

</script>


<!-- <h1>Rezervační formulář</h1> -->
<!-- {#await promiseDownloadData}
    <LoadingBlock />
{:then data}  -->
<!-- <div style="background-color: #FFE5B4; color: #333; padding: 20px; border-radius: 5px; border: 1px solid #FFA07A;">
    <strong>Upozornění:</strong> Došlo k chybě s komunikací na straně serveru. Funkce rezervace byla omezena. Kontaktujte administrátora.
</div> -->
{#if !sent}
<form on:submit|preventDefault={handleSubmit}>
<!-- <div class="u-form-group u-form-select u-label-top u-form-group-1">
    <label class="u-label u-label-1" for="select_service">Vyberte službu</label>
    <div class="u-form-select-wrapper">
        <select id="select-99d3" name="select_service" class="u-input u-input-rectangle u-input-1" bind:value={selectedService}>
            {#each services as service}
                <option value="{service.id}" data-calc="">{service.text}</option>
            {/each}
        </select>
    </div>
</div> -->

<input type="hidden" id="service-uuid" name="service_uuid" value={selectedService}>

<!-- Datum -->
<div class="u-form-date u-form-group u-label-top u-form-group-2" style="position: relative;">
    <label class="u-label u-label-2" for="date">Datum</label>
    <input type="hidden" placeholder="DD/MM/YYYY" id="date-cb49" name="date" class="u-input u-input-rectangle u-input-2 readonly" required="" data-date-format="dd/mm/yyyy">
    <div class="date_calendars_container">
        <Calendars startdate={(new Date())} bind:selectedDate={selectedDate} on:click={() => {promiseDownloadData = downloadData(selectedDate, selectedService)}}></Calendars>
    </div>
 </div>

  <!-- čas -->
{#key selectedDate}
<div class="u-form-date u-form-group u-label-top u-form-group-3" style="position: relative;">
    <label class="u-label u-label-3" for="time">Vybraný termín</label>
    <input type="hidden" id="time-b228" name="time" class="u-input u-input-rectangle u-input-3">
    <div class="time_buttons_container">
        {#await downloadData(selectedDate, selectedService)}
            <LoadingBlock />
        {:then available_reservations}
            {#key selectedDate}
                <DateConfirmator bind:selectedTime={selectedTime} {available_reservations} />
            {/key}
        {:catch error}
            <div style="background-color: #FFE5B4; color: #333; padding: 20px; border-radius: 5px; border: 1px solid #FFA07A;">
                <strong>Upozornění:</strong> V tento den není možné rezervaci vytvořit, služba není otevřená.<br>
                Chyba: {error}
            </div>
        {/await}
    </div>
</div>
{/key}

<div class="u-form-name u-form-group u-label-top">
    <label class="u-label u-label-4" for="name">Jméno a příjmení</label>
    <input type="text" placeholder="Zadejte jméno a přijmení" id="name-78b7" name="name" class="u-input u-input-rectangle u-input-4" required="" bind:value={selectedName}>
</div>
<div class="u-form-email u-form-group u-label-top">
    <label class="u-label u-label-4" for="email">Email</label>
    <input type="email" placeholder="Zadejte e-mail" id="email-78b7" name="email" class="u-input u-input-rectangle u-input-4" required="" bind:value={selectedEmail}>
</div>
<div class="u-form-group u-form-phone u-label-top u-form-group-5">
    <label class="u-label u-label-5" for="phone">Telefonní číslo</label>
    
  <input type="tel" placeholder="+420 111 222 333" id="phone-452f" name="phone" class="u-input u-input-rectangle u-input-5" required="" data-country-code="cz" autocomplete="off" data-intl-tel-input-id="0" bind:value={selectedPhone}>
</div>
<div class="u-align-left u-form-group u-form-submit u-label-top">
    <!-- <a href="#" class="u-btn u-btn-submit u-button-style u-custom-color-3 u-btn-1">Rezervovat</a> -->
    <button class="u-btn u-btn-submit u-button-style u-custom-color-3 u-btn-1" on:click={() => {sent = true;}}>Rezervovat</button>
    <!-- <input type="submit" value="submit" class="u-form-control-hidden"> -->
</div>
</form>
{:else}
    {#await handleSubmit()}
        <LoadingBlock />
    {:then answer} 
    <div style="background-color: #C8E6C9; color: #333; padding: 20px; border-radius: 5px; border: 1px solid #66BB6A;">
        <strong>Úspěch!</strong> Rezervace byla vytvořena!
    </div>
    {:catch error}
    <div style="background-color: #FFCCCC; color: #333; padding: 20px; border-radius: 5px; border: 1px solid #FFA07A;">
        <strong>Chyba:</strong> Došlo k chybě při vytváření rezervace. Rezervace nebyla vytvořena. Pro rezervaci volejte na tel. číslo <strong>+420 XXX XXX XXX</strong> nebo to zkuste znovu.<br/>
        {error}
    </div>
    {/await}
{/if}
<!-- {/await} -->
<style>
 .date_calendars_container {
    margin-bottom: 2rem;
 }
</style>